import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { userManager } from './auth';
import '@fontsource-variable/ibm-plex-sans';   // krój z design systemu, hostowany u nas
// Style są wspólne z panelem operatora (packages/design): ten sam wygląd z jednego źródła
import '@firmeto/design/tokens.css';
import '@firmeto/design/app.css';
import '@firmeto/design/app-shell.css';   // powłoka po zalogowaniu
import '@firmeto/design/entry.css';   // ekrany przed zalogowaniem mają własny układ

// Ciche odnowienie tokenu odbywa się w ukrytej ramce, która ładuje tę samą stronę.
// Wtedy nie budujemy interfejsu — ramka ma tylko oddać wynik oknu głównemu.
if (window.location.pathname === '/logowanie/odnowienie') {
  void userManager.signinSilentCallback();
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
